module.exports = __webpack_public_path__ + "static/media/CADBlack.d449ad13.png";